import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TemplatePortal } from '@angular/cdk/portal';
import { MatButton } from '@angular/material/button';
import { QRScan } from 'app/core/qrscan/qrscan.types';
import { QRScanService } from 'app/core/qrscan/qrscan.service';
import { Shortcut } from 'app/layout/common/shortcuts/shortcuts.types';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { Socket } from 'ngx-socket-io';
import { Router } from '@angular/router';
@Component({
    selector: 'qrscan',
    templateUrl: './qrscan.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'qrscan'
})
export class QRScanComponent implements OnInit, OnDestroy {
    mode: 'view' | 'modify' | 'add' | 'edit' = 'view';
    shortcuts: Shortcut[];
    private _overlayRef: OverlayRef;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @ViewChild('shortcutsOrigin') private _shortcutsOrigin: MatButton;
    @ViewChild('shortcutsPanel') private _shortcutsPanel: TemplateRef<any>;
    qrcode: string = '';
    activationRequests: any = [{ code: 'qrcode1', actv_in: 1 }, { code: 'qrcode2', actv_in: 1 }, { code: 'qrcode3', actv_in: 1 }];

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _shortcutsService: ShortcutsService,
        private _viewContainerRef: ViewContainerRef,
        private _overlay: Overlay,
        // private socket: Socket,
        private _router: Router,
        private _qrscanService: QRScanService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // this.socket.connect();
        this.initSocketData(this);
    }
    getActivatedRequests() {
        this._qrscanService.getActivatedRequests().subscribe((res:any)=>{
            if(res.status == 200){
                this.activationRequests = res.data
            }
        })
    }
    activateUser(data) {
        console.log(data);
        this._qrscanService.saveQRDetails(data).subscribe((res:any)=>{
            if(res.status == 200){
                this._router.navigateByUrl('apps/billing/bill-station/pharmacy')
                this.getActivatedRequests();
            }
        })
    }
    removeUser(data) {
        console.log(data);
        this._qrscanService.removeDetails(data.id).subscribe((res:any)=>{
            if(res.status == 200){
                this.getActivatedRequests();
            }
        })
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // this.socket.disconnect();
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    public getQRCode() {
        this._qrscanService.getQR().subscribe((res: any) => {
            if (res.status == 200 && res.data)
                this.qrcode = JSON.stringify(res.data);
        })
    }

    private initSocketData(self_ref) {
        // this.proceed_flag = false;
        // this.socket.on('connect', () => {
        //     console.log('client connected to server');
        // })
        // this.socket.on('userQRCode', (data) => {
        //     this.activationRequests.push({ code: data, actv_in: 0 });
        // });
    }
    /**
     * Create the overlay
     */
    private _createOverlay(): void {
        // Create the overlay
        this._overlayRef = this._overlay.create({
            hasBackdrop: true,
            backdropClass: 'fuse-backdrop-on-mobile',
            scrollStrategy: this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay.position()
                .flexibleConnectedTo(this._shortcutsOrigin._elementRef.nativeElement)
                .withLockedPosition(true)
                .withPush(true)
                .withPositions([
                    {
                        originX: 'start',
                        originY: 'bottom',
                        overlayX: 'start',
                        overlayY: 'top'
                    },
                    {
                        originX: 'start',
                        originY: 'top',
                        overlayX: 'start',
                        overlayY: 'bottom'
                    },
                    {
                        originX: 'end',
                        originY: 'bottom',
                        overlayX: 'end',
                        overlayY: 'top'
                    },
                    {
                        originX: 'end',
                        originY: 'top',
                        overlayX: 'end',
                        overlayY: 'bottom'
                    }
                ])
        });

        // Detach the overlay from the portal on backdrop click
        this._overlayRef.backdropClick().subscribe(() => {
            this._overlayRef.detach();
        });
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open the shortcuts panel
     */
    openPanel(): void {
        // Return if the shortcuts panel or its origin is not defined
        //  if ( !this._shortcutsPanel || !this._shortcutsOrigin )
        //  {
        //      return;
        //  }

        // Make sure to start in 'view' mode
        this.mode = 'view';

        // Create the overlay if it doesn't exist
        if (!this._overlayRef) {
            this._createOverlay();
        }

        // Attach the portal to the overlay
        this._overlayRef.attach(new TemplatePortal(this._shortcutsPanel, this._viewContainerRef));
    }

    /**
     * Close the messages panel
     */
    closePanel(): void {
        this._overlayRef.detach();
    }
}
